import { gsap, ScrollTrigger, Flip } from "../globals/gsap";

class Filter {
  stateClasses = {
    active: 'active',
    containerSmall: 'teaser__container--small',
    containerRight: 'teaser__container--right',
  };
  duration = 0.5;
  constructor($el) {
    this.$el = $el;
    this.$categories = this.$el.find('[data-filter="category"]');
    this.$items = this.$el.find('[data-filter="item"]');
    this.$content = this.$el.find('[data-filter="content"]');
    this.init();
  }

  init() {
    this.$categories.on('click', this.handleCategoryClick);
  }

  handleCategoryClick = e => {
    const $target = $(e.currentTarget);
    const categoryId = $target.data('id');

    this.$categories.removeClass(this.stateClasses.active);
    $target.addClass(this.stateClasses.active);

    this.filterItems(categoryId);
  };

  filterItems(categoryId) {

    const startState = Flip.getState(this.$items);
    const { containerRight, containerSmall } = this.stateClasses;

    if (categoryId === 'all') {
      this.$items.each((i, el) => {

        el.classList.remove('d-none');
        // el.classList.remove('teaser--push-top');

        // el.classList.remove(containerRight);
        // el.classList.remove(containerSmall);

      });
    } else {
      this.$items.each((i, el) => {
        const categories = el.dataset.categories;
        if (categories.includes(categoryId)) {
          el.classList.remove('d-none');
        } else {
          el.classList.add('d-none');
        }
      });
    }

    const $visibleItems = this.$items.not('.d-none');

    $visibleItems.each((i, el) => {
      const i1 = i+1;
     
      el.classList.remove(containerRight);
      el.classList.remove(containerSmall);

      if (i1 % 4 === 0 || i1 % 4 === 1) {
        el.classList.add(containerSmall);
      }

      if(i1 % 2 == 0) {
        el.classList.add(containerRight);
      }
    });

    this.$content.height(this.$content.height());

    // create a gsap flip animation
    Flip.from(startState, {
      duration: this.duration,
      scale: true,
      absolute: true,
      ease: "power1.inOut",
      onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: this.duration}),
      onComplete: () => {
        this.$content.css('height', '');
      }
    });

    ScrollTrigger.refresh();

  }
}

export default Filter;